import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useSearchParams} from 'react-router-dom';
import api from './Axios/api';
import IndentDetailTable from './DataTables/IndentDetailTable';
import BackBtn from './common/BackBtn';
import Swal from 'sweetalert2';

const IndentDetails = () => {

    const [indent, setIndent] = useState({});
    const [loading, setLoading] = useState(true);
    const [isEditing, setIsEditing] = useState(false);

    const [facLoc, setFacLoc] = useState([]);
    const [staffName, setStaffName] = useState([]);

    const [unit, setUnit] = useState(null);

    const { id } = useParams();
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const fy = searchParams.get("fy");
    const handleIndentDetails = async (id) => {
        try {
            setLoading(true)
            let res;
            if (state?.return) {
                res = await api.get(`/purchase/return-indent-item-list/${id}?fy=${fy}`)
                // console.log("h1",res.data);
            } else {
                res = await api.get(`/indent/get/${id}?fy=${fy}`);
            }
            setIndent(res.data[0])
            // console.log("h2",res.data)
            setUnit(res.data[0].items[0].item_unit)
            setLoading(false)
        } catch (error) {
            console.log(error)
        }

    }

    const handleSave = async () => {
        try {
            const payload = {
                indent_by: indent.indent_by,
                indent_branch_id: indent.indent_branch_id,
                indent_date: indent.indent_date,
                indent_remark: indent.indent_remark,
                indent_number: indent.indent_number,
                indent_status: indent.indent_status,
            };

            const res = await api.patch(`/purchase/edit-return-indent-item-list/${id}`, payload);

            if (res.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Indent updated successfully!',
                    confirmButtonColor: '#4f46e5',
                });
                setIsEditing(false);
                handleIndentDetails(id);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: 'Failed to update indent!',
                    confirmButtonColor: '#dc2626',
                });
            }
        } catch (err) {
            console.error("Update error:", err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while updating!',
                confirmButtonColor: '#dc2626',
            });
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
    }

    const facLocHandler = async () => {
        try {
            const res = await api.get(`/factory-location/get-factory-location`);
            const newData = res.data.map((location) => ({
                value: location._id,
                label: location.fectory_loca_name,
            }));
            setFacLoc(newData);
        } catch (err) {
            console.log(err);
        }
    };

    const staffNames = async () => {
        try {
            const res = await api.get(`/staff/get-staff-name`);
            const newData = res.data.map((staff) => ({
                value: staff._id,
                label: staff.staff_name,
            }));
            setStaffName(newData);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleIndentDetails(id)
        facLocHandler();
        staffNames();
    }, [id])

    return (
        <div className='w-full flex items-center justify-start flex-col '>
            <div className="w-[90%] mt-4 overflow-x-auto ">
                <div className="h-10 px-2 flex justify-between items-center text-violet-500 font-bold rounded-md bg-[#fdfdfd] shadow mb-2">
                    <div>Indent Details</div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => {
                                if (isEditing) {
                                    handleSave();
                                } else {
                                    setIsEditing(true);
                                }
                            }}
                            className="px-5 py-[2px] rounded bg-blue-500 text-white hover:bg-blue-600 text-base"
                        >
                            {isEditing ? 'Save' : 'Edit'}
                        </button>
                        <BackBtn path={"/"} />
                    </div>
                </div>

                <div className="inline-block min-w-full bg-white shadow rounded mb-1">
                    <table className="w-full divide-y divide-gray-200">
                        <tbody className="divide-y divide-gray-200">
                            <tr>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent Factory</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <select
                                            className="border rounded px-2 py-1 w-full"
                                            value={indent.indent_branch_id || ''}
                                            onChange={(e) =>
                                                setIndent({
                                                    ...indent,
                                                    indent_branch_id: e.target.value,
                                                    indent_branch_name: facLoc.find(f => f.value === e.target.value)?.label || '',
                                                })
                                            }
                                        >
                                            <option value="">Select Factory</option>
                                            {facLoc.map((f) => (
                                                <option key={f.value} value={f.value}>
                                                    {f.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : indent.indent_branch_name}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent By</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <select
                                            className="border rounded px-2 py-1 w-full"
                                            value={indent.indent_by || ''}
                                            onChange={(e) =>
                                                setIndent({
                                                    ...indent,
                                                    indent_by: e.target.value,
                                                    indent_by_name: staffName.find(s => s.value === e.target.value)?.label || '',
                                                })
                                            }
                                        >
                                            <option value="">Select Staff</option>
                                            {staffName.map((s) => (
                                                <option key={s.value} value={s.value}>
                                                    {s.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : indent.indent_by_name}
                                </td>
                            </tr>
                            <tr>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent Date</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <input
                                            type="date"
                                            className="border rounded px-2 py-1"
                                            value={indent.indent_date?.split('T')[0] || ''}
                                            onChange={(e) =>
                                                setIndent({ ...indent, indent_date: e.target.value })
                                            }
                                        />
                                    ) : formatDate(indent.indent_date)}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent Remark</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            className="border rounded px-2 py-1 w-full"
                                            value={indent.indent_remark || ''}
                                            onChange={(e) =>
                                                setIndent({ ...indent, indent_remark: e.target.value })
                                            }
                                        />
                                    ) : indent.indent_remark}
                                </td>
                            </tr>
                            <tr>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent No.</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            className="border rounded px-2 py-1 w-full"
                                            value={indent.indent_number || ''}
                                            onChange={(e) =>
                                                setIndent({ ...indent, indent_number: e.target.value })
                                            }
                                        />
                                    ) : indent.indent_number}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900">Indent Status</td>
                                <td className="px-6 py-4">
                                    {isEditing ? (
                                        <select
                                            className="border rounded px-2 py-1"
                                            value={indent.indent_status || ''}
                                            onChange={(e) =>
                                                setIndent({ ...indent, indent_status: e.target.value })
                                            }
                                        >
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    ) : indent.indent_status}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {
                    loading ?
                        <div>Loading....</div> :
                        <IndentDetailTable data={indent?.items} type={state?.return} />
                }

            </div>
        </div>
    );
};

export default IndentDetails;